import { ILogs } from 'interfaces';
import { BaseService } from './BaseService';
import { axiosPrivate } from 'services/axios';

class LogService extends BaseService<ILogs> {
  constructor() {
    super('auditlogs');
  }
  canBulkDelete = true;

  getModels = async () => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/models/`);
    return res.data;
  };

  getVersions = async (
    model: string,
    object_id: string,
    fields: Record<string, string>,
    pagination?: { limit?: number; offset?: number }
  ) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/get_versions/`, {
      model,
      object_id,
      fields,
      limit: pagination?.limit,
      offset: pagination?.offset
    });
    return res.data;
  };

  getVersionsByActor = async (
    actorName: string,
    pagination?: { limit?: number; offset?: number }
  ) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/get_versions/`, {
      actor_name: actorName,
      limit: pagination?.limit,
      offset: pagination?.offset
    });
    return res.data;
  };
}

export const logService = new LogService();
